import * as React from "react";
import { FooterConfiguration } from "../footer/footer";
import Survey from "../survey/survey";
import Questions from "../questions/questions";
import Result from "../result/result";
import getQuestions, { QuestionDTO } from "../../services/questions";

import styles from "./main.module.scss";
import Header from "../header/header";

type MainProps = {
    setFooter: (config: FooterConfiguration) => void;
};

export type ChildProps = {
    setFooter: (config: FooterConfiguration) => void;
    setPage: (page: PageType) => void;
};

export enum PageType {
    survey = "survey",
    question = "questions",
    result = "result",
}

const Main = (props: MainProps) => {
    const { setFooter } = props;

    const [page, setPage] = React.useState(PageType.survey);
    const questionsArr: QuestionDTO[] = [];
    const [questions, setQuestions] = React.useState(questionsArr);
    const [quiz, setQuiz] = React.useState(undefined as string | undefined);

    React.useEffect(() => {
        async function fetchData() {
            if (!quiz) return;
            const response = await getQuestions(quiz);
            if (response) setQuestions(response);
        }
        if (page === PageType.survey) {
            fetchData();
            sessionStorage.clear();
        }
    }, [page, quiz]);

    React.useEffect(() => {
        if (quiz === undefined) {
            window.onbeforeunload = () => undefined;
        }
    }, [quiz]);

    const component = (
        <Component
            setFooter={setFooter}
            setPage={setPage}
            page={page}
            questions={questions}
            quiz={quiz || ""}
            setQuiz={setQuiz}
        />
    );

    return (
        <>
            <Header
                goHome={() => {
                    setQuiz(undefined);
                    setPage(PageType.survey);
                    setFooter({ Button: undefined });
                    sessionStorage.clear();
                }}
            />
            <div className={styles.main}>
                <div className={styles.container}>
                    {!quiz && (
                        <div className={styles.quizChoice}>
                            <div className={styles.title}>Choose a quiz</div>
                            <button className={"quiz_button"} onClick={() => setQuiz("GB")}>
                                General Boating
                            </button>
                            <br />
                            <br />
                            <br />
                            <button className={"quiz_button"} onClick={() => setQuiz("PWC")}>
                                Personal Watercraft
                            </button>
                        </div>
                    )}
                    {quiz && component}
                </div>
            </div>
        </>
    );
};

const Component = (
    props: ChildProps & {
        page: PageType;
        questions: QuestionDTO[];
        quiz: string;
        setQuiz: (quiz: string | undefined) => void;
    }
): JSX.Element | null => {
    const { setFooter, setPage, setQuiz, page, questions, quiz } = props;

    const childProps: ChildProps = {
        setFooter,
        setPage,
    };

    const setPageToStart = (page: PageType) => {
        setPage(page);
        setQuiz(undefined);
    };

    switch (page) {
        case PageType.survey:
            return <Survey {...childProps} quiz={quiz} />;
        case PageType.question:
            return <Questions {...childProps} questions={questions} />;
        case PageType.result:
            return <Result setFooter={setFooter} setPage={setPageToStart} questions={questions} />;
        default:
            return null;
    }
};

export default Main;
